var Backbone = require('backbone');
//var sw = require('./../sw');

var ModelCocreator = Backbone.Model.extend({

	idAttribute: 'id',
  pluralName:  'modelCocreators',

  defaults: {
    'id': -1
  }

});

module.exports = ModelCocreator;